export default __webpack_public_path__ + "static/tooltip-interactive-2-dont-dark-76cd39b3c8287ad00aad38e17b719467652f56b2b8502bd9fe14e6cde183f1d9.png";